import { render, staticRenderFns } from "./offer-group.vue?vue&type=template&id=0bbf47c5&scoped=true"
import script from "./offer-group.vue?vue&type=script&lang=js"
export * from "./offer-group.vue?vue&type=script&lang=js"
import style0 from "./offer-group.vue?vue&type=style&index=0&id=0bbf47c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf47c5",
  null
  
)

export default component.exports